import React from 'react';
import PropTypes from 'prop-types';
import { Bert } from 'meteor/themeteorchef:bert';
import { isEmpty, isNaN, map } from 'lodash';

import {
  Box,
  Button,
  Chip,
  Fab,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Modal,
  OutlinedInput,
  Paper,
  Select,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography
} from '@mui/material';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import CachedIcon from '@mui/icons-material/Cached';
import CloseIcon from '@mui/icons-material/Close';
import DriveFolderUploadOutlinedIcon from '@mui/icons-material/DriveFolderUploadOutlined';
import DownloadIcon from '@mui/icons-material/Download';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import MapIcon from '@mui/icons-material/Map';
import NearMeIcon from '@mui/icons-material/NearMe';
import NearMeOutlinedIcon from '@mui/icons-material/NearMeOutlined';
import PlaceIcon from '@mui/icons-material/Place';
import RectangleIcon from '@mui/icons-material/Rectangle';
import SearchIcon from '@mui/icons-material/Search';
import VisibilityIcon from '@mui/icons-material/Visibility';
import LoadingSliderComponent from '../LoadingSliderComponent';
import ImportFileToBackend from '../ImportFileToBackend';
import methodPromise from '../../../modules/method-promise-wrapper';
import Loading from '../Loading';
import { useStyles } from '../../../styles/mapStylesCustom';
import useTimeStore from '../ZustandProvider';
import generateNewWindowContent from './generateNewWindowContent';

let pushLoading = false;
let showDownloadLoading = false;

const DownloadLinksComponent = ({ isMobile, MapProps }) => {
  const coordOnMap = useTimeStore(state => state.coordOnMap);
  const dataToSend = useTimeStore(state => state.dataToSend);
  const geometryConfig = useTimeStore(state => state.geometryConfig);
  const setDataToSend = useTimeStore(state => state.setDataToSend);
  const setGeometryConfig = useTimeStore(state => state.setGeometryConfig);
  const setGoToCoordinates = useTimeStore(state => state.setGoToCoordinates);

  const { server, source, connector, importFile } = MapProps.map.settingsAdvancedMap.connections;
  const [categories, setCategories] = React.useState({});
  const classes = useStyles();
  const [coordinateSystemsArray, setCoordinateSystemsArray] = React.useState([]);
  const [coordsConvert, setCoordsConvert] = React.useState([]);
  const [coordSystemIn, setCoordSystemIn] = React.useState('EPSG:4326');
  const [coordSystemOut, setCoordSystemOut] = React.useState('EPSG:4326');
  const [currentLocation, setCurrentLocation] = React.useState({});
  const [firstAnswer, setFirstAnswer] = React.useState({});
  const [informationSettings, setInformationSettings] = React.useState('');
  const [infoToDownload, setInfoToDownload] = React.useState([]);
  const [inputString, setInputString] = React.useState('Seleccionar punto');
  const [inputCoords, setInputCoords] = React.useState({});
  const [isLoadingIpsilum, setIsLoadingIpsilum] = React.useState(false);
  const [groupOfProductDownload, setGroupOfProductDownload] = React.useState([]);
  const [groupOfProductSelected, setGroupOfProductSelected] = React.useState([]);
  const [openInfoCatastro, setOpenInfoCatastro] = React.useState(false);
  const [openModalAllDownload, setOpenModalAllDownload] = React.useState(false);
  const [openModalViewLink, setOpenModalViewLink] = React.useState(false);
  const [openSettingsPoint, setOpenSettingsPoint] = React.useState(false);
  const rowsPerPage = 6;
  const [sourceSelect, setSourceSelect] = React.useState(!isEmpty(source) ? source[0] : {});
  const [table, setTable] = React.useState([]);
  const [tablePage, setTablePage] = React.useState(0);
  const [tableSelected, setTableSelected] = React.useState({});
  const [typeFiles, setTypeFiles] = React.useState([]);
  const [typeFilesSelected, setTypeFilesSelected] = React.useState({});
  const [typeFilesSelectedToDownload, setTypeFilesSelectedToDownload] = React.useState({});
  const [typeToDownload, setTypeToDownload] = React.useState({});
  const [viewDownloadSelected, setViewDownloadSelected] = React.useState({});
  const [viewLinkSelected, setViewLinkSelected] = React.useState('');

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;

  const urlCall = () => {
    let url;
    if (server.serverType === 'IGP') {
      url = `http://${server.ip}:${server.port}/MG/lidar/exec_filter_lidar`;
    } else if (server.serverType === 'IGPS' || server.serverType === 'input') {
      url = `${server.domain}/MG/lidar/exec_filter_lidar`;
    }
    return url;
  };
  const urlConvertCoods = () => {
    let url;
    if (server.serverType === 'IGP') {
      url = `http://${server.ip}:${server.port}/MG/lidar/exec_translate_coords`;
    } else if (server.serverType === 'IGPS' || server.serverType === 'input') {
      url = `${server.domain}/MG/lidar/exec_translate_coords`;
    }
    return url;
  };
  const dataBase = {
    host: connector.ip,
    port: connector.port,
    database: connector.databaseName,
    user: connector.user,
    password: connector.password,
    esquema: connector.schema,
    tabla: 'configuration'
  };

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250
      }
    }
  };

  const getModalStyleDownload = () => {
    const top = 10;
    return {
      top: `${top}%`,
      width: '50%',
      height: '80%'
    };
  };

  const LightTooltip = styled(({ className, ...prop }) => (
    <Tooltip {...prop} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,
      color: 'rgba(0, 0, 0, 0.87)',
      boxShadow: 'none',
      fontSize: 11
    }
  }));

  const [modalStyleDownload] = React.useState(getModalStyleDownload);

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: '#757575',
      color: theme.palette.common.white
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14
    }
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0
    }
  }));

  const convertCoordsFunction = async (inSystem, outSystem) => {
    if (!isEmpty(coordOnMap)) {
      const response = await fetch(urlConvertCoods(), {
        method: 'POST',
        body: JSON.stringify({
          coordSystem: [inSystem, outSystem],
          point: [coordOnMap.lat, coordOnMap.lng],
          user: 'None'
        }),
        headers: { 'Content-Type': 'application/json' },
        mode: 'cors',
        credentials: 'omit',
        referrerPolicy: 'no-referrer'
      });
      const respuesta = await response.json();
      setInputCoords({ lat: respuesta[0], lng: respuesta[1] });
      setDataToSend(coordOnMap);
    }
  };

  const handleAllDownload = () => {
    map(infoToDownload, index => {
      const links = index.list.map(element => element.downloadLink);
      if (links.length <= 250) {
        for (let i = 0; i < links.length; i += 1) {
          const frame = document.createElement('iframe');
          frame.src = links[i];
          frame.download = 1;
          document.body.appendChild(frame);
        }
      } else {
        Bert.alert('No se pueden descargar más de 250 archivos', 'warning');
      }
    });
  };

  const handleChange = value => {
    const objeto = {
      product: viewDownloadSelected.product,
      group: typeof value === 'string' ? value.split(',') : value
    };
    const index = typeFilesSelectedToDownload.findIndex(
      file => file.product === viewDownloadSelected.product
    );
    if (isEmpty(objeto.group)) {
      typeFilesSelectedToDownload.splice(index, 1);
    } else if (index < 0) {
      typeFilesSelectedToDownload.push(objeto);
    } else {
      typeFilesSelectedToDownload[index] = objeto;
    }

    setViewDownloadSelected(objeto);
  };

  const handleChangePage = (event, newPage) => {
    setTablePage(newPage);
  };

  const handleDownload = () => {
    const windowFeatures = 'width=400,height=400';
    const newWindow = window.open('', '_blank', windowFeatures);

    const content = generateNewWindowContent(firstAnswer[0].list);
    newWindow.document.write(content);

    const links = firstAnswer[0].list.map(element => element.downloadLink);

    for (let i = 0; i < links.length; i += 1) {
      const frame = document.createElement('iframe');
      frame.src = links[i];
      frame.download = 1;
      document.body.appendChild(frame);
    }
  };

  const getLinkLidarMap = async () => {
    const urlFunction = () => {
      let url;
      if (server.serverType === 'IGP') {
        url = `http://${server.ip}:${server.port}/MG/lidar/write_lidar_html`;
      } else if (server.serverType === 'IGPS' || server.serverType === 'input') {
        url = `${server.domain}/MG/lidar/write_lidar_html`;
      }
      return url;
    };
    if (!isEmpty(dataToSend)) {
      try {
        const response = await fetch(urlFunction(), {
          method: 'POST',
          body: JSON.stringify({
            disc: 'data3',
            ftpIp: '',
            ftpPort: '',
            ftpUser: '',
            ftpPassword: '',
            httpPort: '',
            projectsEntwine: [sourceSelect.path],
            projectName: '',
            projectPath: 'htmls/lidar/tempwines',
            position: [dataToSend.lat, dataToSend.lng],
            user: ''
          }),
          headers: { 'Content-Type': 'application/json' },
          mode: 'cors',
          credentials: 'omit',
          referrerPolicy: 'no-referrer'
        });

        const respuesta = await response.json();
        setViewLinkSelected(respuesta.htmlCreated);
      } catch (error) {
        Bert.alert('No se encuentra mapa en estas coordenadas', 'error');
      } finally {
        setIsLoadingIpsilum(true);
        setOpenModalViewLink(true);
        setTimeout(() => {
          setIsLoadingIpsilum(false);
        }, 3000);
      }
    } else {
      Bert.alert('Selecciona un punto del mapa', 'warning');
    }
  };

  const renderComponent = (name, prop) => {
    switch (name) {
      case 'punto':
        return [dataToSend.lat, dataToSend.lng];

      case 'poligono':
        return dataToSend;
      default:
        if (prop === 'PointOnMap') {
          return [dataToSend.lat, dataToSend.lng];
        }
        return inputString;
    }
  };

  const renderIcon = name => {
    switch (name) {
      case 'catastro':
        return <FilterAltOutlinedIcon sx={{ mr: 1 }} />;
      case 'poligono':
        return <RectangleIcon sx={{ mr: 1 }} />;
      case 'punto':
        return <PlaceIcon sx={{ mr: 1 }} />;
      case 'importar':
        return <DriveFolderUploadOutlinedIcon sx={{ mr: 1 }} />;
      default:
        return <SearchIcon sx={{ mr: 1 }} />;
    }
  };

  const sendInfoDownloadToBack = async row => {
    try {
      const data = firstAnswer[0];
      data.list = [row];
      const infoUser = {
        currentLocation,
        mapId: MapProps.map._id,
        mapName: MapProps.map.name,
        product: groupOfProductDownload,
        userId: MapProps.map.owner,
        time: `${`${new Date().getDate()}-${new Date().getMonth() +
          1}-${new Date().getFullYear()}` +
          ' '}${new Date().getHours()}:${new Date().getMinutes()}:${new Date().getSeconds()}`
      };
      fetch(urlCall(), {
        method: 'POST',
        body: JSON.stringify({
          coordSystem: '',
          dataBase,
          inputFile: data,
          mongo: [],
          point: '',
          user: infoUser,
          tableId: '',
          tableFilter: '',
          typeGeometry: 'Download',
          typeFile: ''
        }),
        headers: { 'Content-Type': 'application/json' },
        mode: 'cors',
        credentials: 'omit',
        referrerPolicy: 'no-referrer'
      });
    } catch (error) {
      Bert.alert('Select another data', 'danger');
    }
  };

  const syncConvertCoordsFunction = async (inSystem, outSystem) => {
    const response = await fetch(urlConvertCoods(), {
      method: 'POST',
      body: JSON.stringify({
        coordSystem: [inSystem, outSystem],
        point: [coordOnMap.lat, coordOnMap.lng],
        user: 'None'
      }),
      headers: { 'Content-Type': 'application/json' }
    });
    const respuesta = await response.json();
    setCoordsConvert(respuesta);
  };

  const convertFunction = async (latitud, longitud) => {
    const response = await fetch(urlConvertCoods(), {
      method: 'POST',
      body: JSON.stringify({
        coordSystem: [coordSystemIn, 'EPSG:4326'],
        point: [latitud, longitud],
        user: 'None'
      }),
      headers: { 'Content-Type': 'application/json' }
    });
    const respuesta = await response.json();
    if (isEmpty(respuesta)) {
      setDataToSend({ lat: respuesta[0], lng: respuesta[1] });
      setGoToCoordinates({ lat: respuesta[0], lng: respuesta[1] });
    }
  };

  const callToBack = async (typeFile, prop, tableProp) => {
    try {
      const { id, name } = typeToDownload;
      setInfoToDownload({});
      const mongo = [];
      if (prop !== 'download') {
        setFirstAnswer({});
      }
      const typeGeometry = () => {
        if (prop === 'cargar' && name === 'otros') {
          return 'colide_with_geometry';
        }
        if (prop === 'search' && name !== 'catastro') {
          return prop;
        }
        return id;
      };
      const infoUser = {
        currentLocation,
        mapId: MapProps.map._id,
        mapName: MapProps.map.name,
        userId: MapProps.map.owner,
        time: `${`${new Date().getDate()}-${new Date().getMonth() +
          1}-${new Date().getFullYear()}` +
          ' '}${new Date().getHours()}:${new Date().getMinutes()}:${new Date().getSeconds()}`
      };
      const dataPoint = renderComponent(name, prop);
      if (!isEmpty(dataPoint)) {
        const response = await fetch(urlCall(), {
          method: 'POST',
          body: JSON.stringify({
            coordSystem: 'EPSG:4326',
            dataBase,
            inputFile: '',
            mongo,
            point: dataPoint,
            user: prop !== 'download' && infoUser,
            tableId: name === 'otros' ? tableProp.id : '',
            tableFilter: name === 'otros' ? tableProp.search : '',
            typeGeometry: typeGeometry(),
            typeFile
          }),
          headers: { 'Content-Type': 'application/json' },
          mode: 'cors',
          credentials: 'omit',
          referrerPolicy: 'no-referrer'
        });
        const respuesta = await response.json();

        if (respuesta[0].information) {
          setInformationSettings(respuesta[0].information);
        }
        if (respuesta[0].centroide) {
          setGoToCoordinates(respuesta[0].centroide);
        }

        if (prop === 'download') {
          setInfoToDownload(respuesta);
        } else if (prop === 'PointOnMap') {
          setInputString(respuesta[0].list[0].name);
        } else {
          setFirstAnswer(respuesta);
        }
      } else {
        Bert.alert('Selecciona un punto en el mapa o introduzcalo', 'warning');
      }
    } catch (error) {
      setInputString('');
      Bert.alert('No se encuentran datos', 'danger');
    }
  };

  const bodyAllDownload = (
    <div style={modalStyleDownload} className={classes.modalPaperAuto}>
      {!isEmpty(viewDownloadSelected) && (
        <Grid container>
          <br />
          <h2>Opciones de descarga</h2>
          <Grid item xs={3} />
          <Grid item xs={6}>
            {!isEmpty(typeFiles) && !isEmpty(groupOfProductDownload) && (
              <Box
                component="form"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-evenly',
                  gap: 2,
                  mb: 2,
                  mt: 2,
                  width: '100%'
                }}
                noValidate
                autoComplete="off"
              >
                <FormControl>
                  <InputLabel id="demo-select-label">Producto</InputLabel>
                  <Select
                    labelId="demo-select-label"
                    id="demo-select"
                    label="Producto"
                    size="small"
                    sx={{ minWidth: 120 }}
                    value={viewDownloadSelected.product}
                    onChange={event => {
                      const index = typeFiles.findIndex(
                        file => file.product === event.target.value
                      );
                      setGroupOfProductDownload(typeFiles[index].group);
                      const indexSelected = typeFilesSelectedToDownload.findIndex(
                        file => file.product === event.target.value
                      );
                      setViewDownloadSelected({
                        product: event.target.value,
                        group:
                          indexSelected < 0 ? [] : typeFilesSelectedToDownload[indexSelected].group
                      });
                    }}
                  >
                    {typeFiles.map(item => (
                      <MenuItem key={item.product} value={item.product}>
                        {item.product}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl>
                  <InputLabel id="demo-multiple-chip-label">Versión</InputLabel>
                  <Select
                    labelId="demo-multiple-chip-label"
                    label="Versión"
                    id="demo-multiple-chip"
                    size="small"
                    multiple
                    sx={{ minWidth: 120 }}
                    value={viewDownloadSelected.group}
                    onChange={e => handleChange(e.target.value)}
                    input={<OutlinedInput id="select-multiple-chip" label="Versión" />}
                    renderValue={selected => (
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {selected.map(value => (
                          <Chip key={value} label={value} />
                        ))}
                      </Box>
                    )}
                    MenuProps={MenuProps}
                  >
                    {groupOfProductDownload.map(item => (
                      <MenuItem key={item} value={item}>
                        {item}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <Button
                  variant="outlined"
                  color="success"
                  onClick={() => {
                    showDownloadLoading = true;
                    callToBack(typeFilesSelectedToDownload, 'download', tableSelected);
                  }}
                  startIcon={<VisibilityIcon />}
                >
                  Mostrar
                </Button>
              </Box>
            )}
            {showDownloadLoading === true && (
              <>
                {!isEmpty(infoToDownload) && !infoToDownload.message ? (
                  <>
                    {infoToDownload.map(item => {
                      return (
                        <>
                          <div style={{ display: 'flex' }}>
                            <h4>
                              {item.product}-{item.group}
                            </h4>
                          </div>
                          <TableContainer component={Paper}>
                            <Table aria-label="customized table" size="small" stickyHeader>
                              <TableHead>
                                <TableRow>
                                  <StyledTableCell align="left">Links</StyledTableCell>
                                  <StyledTableCell align="right" />
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {item.list
                                  .slice(
                                    tablePage * rowsPerPage,
                                    tablePage * rowsPerPage + rowsPerPage
                                  )
                                  .map(row => {
                                    return (
                                      <StyledTableRow key={row.name}>
                                        <StyledTableCell component="th" scope="row">
                                          {row.name}
                                        </StyledTableCell>
                                        <StyledTableCell align="right">
                                          <Stack
                                            color="inherit"
                                            size="small"
                                            direction="row"
                                            justifyContent="flex-end"
                                            alignItems="center"
                                            spacing={0}
                                          >
                                            <IconButton
                                              size="small"
                                              aria-label="viewData"
                                              onClick={() => {
                                                setViewLinkSelected(row.htmlCreated);
                                                setOpenModalViewLink();
                                              }}
                                            >
                                              <VisibilityIcon />
                                            </IconButton>
                                            <IconButton
                                              size="small"
                                              aria-label="download"
                                              onClick={() => {
                                                const data = item;
                                                data.list = row;
                                                window.location.href = row.downloadLink;
                                                sendInfoDownloadToBack(data);
                                              }}
                                            >
                                              <DownloadIcon />
                                            </IconButton>
                                          </Stack>
                                        </StyledTableCell>
                                      </StyledTableRow>
                                    );
                                  })}
                              </TableBody>
                            </Table>
                          </TableContainer>
                          <TablePagination
                            rowsPerPageOptions={[5]}
                            component="div"
                            count={firstAnswer[0].list.length}
                            rowsPerPage={rowsPerPage}
                            page={tablePage}
                            onPageChange={handleChangePage}
                          />
                          <Button
                            variant="outlined"
                            size="small"
                            color="success"
                            onClick={() => {
                              handleAllDownload();
                              sendInfoDownloadToBack(item);
                            }}
                            startIcon={<DownloadIcon />}
                          >
                            Descargar
                          </Button>
                        </>
                      );
                    })}
                  </>
                ) : (
                  <Loading />
                )}
              </>
            )}
          </Grid>
          <Grid item xs={3} />
        </Grid>
      )}
    </div>
  );

  const bodyViewLink = (
    <Modal open={openModalViewLink} onClose={() => setOpenModalViewLink(false)}>
      <Box backgroundColor="white" height="100%" width="100%">
        {isLoadingIpsilum && (
          <LoadingSliderComponent loadingTime={3000} isLoadingIpsilum={isLoadingIpsilum} />
        )}
        <Box
          height="5%"
          width="100%"
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0 16px'
          }}
        >
          <Typography variant="h5" fontWeight="bold">
            {sourceSelect.name}
          </Typography>
          <IconButton
            color="success"
            variant="outlined"
            onClick={() => {
              setOpenModalViewLink(false);
            }}
            sx={{ marginLeft: 'auto' }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <Box height="95%" width="100%">
          {viewLinkSelected && (
            <iframe title="WebPage" src={viewLinkSelected} width="100%" height="100%" />
          )}
        </Box>
      </Box>
    </Modal>
  );

  React.useEffect(() => {
    const findAnswer = async () => {
      const infoUser = {
        currentLocation,
        mapId: MapProps.map._id,
        mapName: MapProps.map.name,
        userId: MapProps.map.owner,
        time: `${`${new Date().getDate()}-${new Date().getMonth() +
          1}-${new Date().getFullYear()}` +
          ' '}${new Date().getHours()}:${new Date().getMinutes()}:${new Date().getSeconds()}`
      };
      const response = await fetch(urlCall(), {
        method: 'POST',
        body: JSON.stringify({
          dataBase,
          mongo: 'none',
          point: false,
          typeFile: '',
          typeGeometry: 'Request',
          user: infoUser
        }),
        headers: { 'Content-Type': 'application/json' },
        mode: 'cors',
        credentials: 'omit',
        referrerPolicy: 'no-referrer'
      });
      const respuesta = await response.json();

      if (!isEmpty(respuesta)) {
        setCategories(respuesta[0]);
        if (respuesta[0].length > 0) {
          const firstCategory = respuesta[0][0];
          setTypeToDownload({ name: firstCategory.name.toLowerCase(), id: firstCategory.id });
          setGeometryConfig(firstCategory.name.toLowerCase());
        }
        setTable(respuesta[1]);
        setTableSelected(respuesta[1][0]);
        setCoordinateSystemsArray(respuesta[2]);
        setTypeFiles(respuesta[3]);
        setTypeFilesSelected({
          product: respuesta[3][0].product,
          group: [respuesta[3][0].group[0]]
        });
        setTypeFilesSelectedToDownload([
          {
            product: respuesta[3][0].product,
            group: [respuesta[3][0].group[0]]
          }
        ]);
        setViewDownloadSelected({
          product: respuesta[3][0].product,
          group: [respuesta[3][0].group[0]]
        });
        setGroupOfProductSelected(respuesta[3][0].group);
        setGroupOfProductDownload(respuesta[3][0].group);
      }
      navigator.geolocation.getCurrentPosition(position => {
        const coordinates = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude
        };
        setCurrentLocation(coordinates);
      });
    };
    findAnswer();
  }, []);

  React.useEffect(() => {
    if (geometryConfig !== 'NotesMaps' || geometryConfig !== 'Sentinel') {
      if (coordSystemIn === 'EPSG:4326') {
        setInputCoords(coordOnMap);
        setDataToSend(coordOnMap);
      } else {
        convertCoordsFunction('EPSG:4326', coordSystemIn);
      }
    }
  }, [coordOnMap]);

  React.useEffect(() => {
    pushLoading = false;
    if (geometryConfig === 'sync') {
      syncConvertCoordsFunction(coordSystemIn, coordSystemOut);
    } else if (typeToDownload.name === 'catastro' || typeToDownload.name === 'otros') {
      callToBack([typeFilesSelected], 'PointOnMap', tableSelected);
    } else if (!isEmpty(dataToSend)) {
      setGoToCoordinates([dataToSend.lat, dataToSend.lng]);
    }
  }, [dataToSend]);

  React.useEffect(() => {
    const otherType = !(
      typeToDownload.name === 'punto' ||
      typeToDownload.name === 'poligono' ||
      typeToDownload.name === 'catastro' ||
      typeToDownload.name === 'importar' ||
      typeToDownload.name === 'otros'
    );
    setInputString('');
    setFirstAnswer({});
    setInputCoords({});
    setTypeToDownload({ ...typeToDownload, otherType });
  }, [typeToDownload.name]);

  return (
    <>
      {server && (
        <>
          <Grid container spacing={1} mt={1} mb={4} alignItems="stretch">
            {!isEmpty(categories) ? (
              <>
                <Grid item xs={isMobile === true ? 6 : 4}>
                  <Stack direction="column" justifyContent="space-around" spacing={0.5}>
                    {map(categories, ({ name, id }) => {
                      if (id === 'import' && !importFile) {
                        return null;
                      }
                      return (
                        <Fab
                          key={name}
                          variant="extended"
                          size="small"
                          style={{
                            color: typeToDownload.name === name.toLowerCase() ? 'white' : '#2A3F90',
                            backgroundColor:
                              typeToDownload.name === name.toLowerCase() ? '#2A3F90' : 'white',
                            boxShadow: 'none',
                            justifyContent: 'flex-start'
                          }}
                          onClick={() => {
                            pushLoading = false;
                            setCoordSystemIn('EPSG:4326');
                            setInformationSettings('');
                            setTypeToDownload({ name: name.toLowerCase(), id });
                            setGeometryConfig(name.toLowerCase());
                          }}
                        >
                          {renderIcon(name.toLowerCase())}
                          {name}
                        </Fab>
                      );
                    })}
                  </Stack>
                </Grid>
                <Grid item xs={isMobile === true ? 12 : 8} mb={2}>
                  {typeToDownload.name === 'punto' && typeToDownload.otherType !== true && (
                    <>
                      <FormControl fullWidth sx={{ mb: 1 }}>
                        <InputLabel id="demo-select-label">Sistema de coordenadas</InputLabel>
                        <Select
                          labelId="demo-select-label"
                          id="demo-select"
                          size="small"
                          label="Sistema de coordenadas"
                          value={isEmpty(coordSystemIn) ? coordinateSystemsArray[0] : coordSystemIn}
                          onChange={async event => {
                            setCoordSystemIn(event.target.value);
                            if (event.target.value !== 'EPSG:4326') {
                              convertCoordsFunction('EPSG:4326', event.target.value);
                            }
                          }}
                        >
                          {coordinateSystemsArray.map(option => (
                            <MenuItem key={option} value={option}>
                              {option}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <Box
                        component="form"
                        sx={{
                          display: isMobile === true ? 'column' : 'flex',
                          alignItems: 'center',
                          gap: 2,
                          mb: 2,
                          width: '100%'
                        }}
                        noValidate
                        autoComplete="off"
                      >
                        <TextField
                          id="outlined-start-adornment"
                          focused
                          fullWidth
                          size="small"
                          sx={{ mb: isMobile === true ? 1 : '0px' }}
                          label={coordSystemIn === 'EPSG:4326' ? 'Latitud' : 'Y'}
                          onChange={e => {
                            setInputCoords({ lat: e.target.value, lng: inputCoords.lng });
                          }}
                          value={isEmpty(inputCoords) ? 'Latitud' : inputCoords.lat}
                        />
                        <TextField
                          id="outlined-multiline-flexible"
                          focused
                          fullWidth
                          label={coordSystemIn === 'EPSG:4326' ? 'Longitud' : 'X'}
                          size="small"
                          onChange={e => {
                            setInputCoords({ lat: inputCoords.lat, lng: e.target.value });
                          }}
                          value={isEmpty(inputCoords) ? 'Longitud' : inputCoords.lng}
                        />
                        <IconButton
                          style={{ color: '#2A3F90' }}
                          onClick={() => {
                            const latitud = !isNaN(parseFloat(inputCoords.lat))
                              ? parseFloat(inputCoords.lat)
                              : (Bert.alert('La latitud no es un número', 'warning'), null);

                            const longitud = !isNaN(parseFloat(inputCoords.lng))
                              ? parseFloat(inputCoords.lng)
                              : (Bert.alert('La longitud no es un número', 'warning'), null);

                            if (latitud !== null && longitud !== null) {
                              if (coordSystemIn === 'EPSG:4326') {
                                setDataToSend({ lat: latitud, lng: longitud });
                              } else {
                                convertFunction(latitud, longitud);
                              }
                              setInputCoords({ lat: latitud, lng: longitud });
                            }
                          }}
                        >
                          <NearMeIcon />
                        </IconButton>
                      </Box>
                      <Button
                        aria-label="Configuración"
                        onClick={() => {
                          setOpenSettingsPoint(!openSettingsPoint);
                        }}
                        sx={{ color: '#2A3F90', mb: 2 }}
                        size="small"
                      >
                        {openSettingsPoint === true ? (
                          <KeyboardArrowUpIcon />
                        ) : (
                          <KeyboardArrowDownIcon />
                        )}
                        Herramientas
                      </Button>

                      {openSettingsPoint === true && (
                        <>
                          {!isEmpty(source) && (
                            <FormControl fullWidth sx={{ mb: 1 }}>
                              <InputLabel id="demo-select-label">Sources</InputLabel>
                              <Select
                                id="demo-select"
                                label="Sources"
                                labelId="demo-select-label"
                                onChange={event => {
                                  const index = source.findIndex(
                                    item => item.name === event.target.value
                                  );
                                  setSourceSelect(source[index]);
                                }}
                                size="small"
                                value={isEmpty(sourceSelect) ? source[0].name : sourceSelect.name}
                              >
                                {source.map(element => (
                                  <MenuItem key={element.name} value={element.name}>
                                    {element.name}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          )}
                          <FormControl fullWidth sx={{ mb: 1 }}>
                            <InputLabel id="demo-select-label">Ver en:</InputLabel>
                            <Select
                              id="demo-select"
                              label="Ver en:"
                              labelId="demo-select-label"
                              onChange={async event => {
                                setCoordSystemOut(event.target.value);
                                const respuesta = await methodPromise('maps.convertCoords', {
                                  coordSystem: [coordSystemIn, event.target.value],
                                  point: [dataToSend.lat, dataToSend.lng],
                                  user: 'None'
                                });
                                setCoordsConvert(respuesta);
                              }}
                              size="small"
                              value={
                                isEmpty(coordSystemOut) ? coordinateSystemsArray[0] : coordSystemOut
                              }
                            >
                              {coordinateSystemsArray.map(option => (
                                <MenuItem key={option} value={option}>
                                  {option}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          <Box
                            component="form"
                            sx={{
                              display: 'flex',
                              mb: 1,
                              width: '100%'
                            }}
                            noValidate
                            autoComplete="off"
                          >
                            <Stack
                              direction="row"
                              justifyContent="space-evenly"
                              spacing={1}
                              xs={{
                                boxShadow: 'none'
                              }}
                            >
                              <Button
                                onClick={() => {
                                  if (geometryConfig === 'sync') {
                                    setGeometryConfig('punto');
                                  } else {
                                    setGeometryConfig('sync');
                                    syncConvertCoordsFunction('EPSG:4326', coordSystemIn);
                                  }
                                }}
                                variant="outlined"
                                style={{
                                  color: geometryConfig === 'sync' ? 'white' : '#2A3F90',
                                  backgroundColor: geometryConfig === 'sync' ? '#2A3F90' : 'white',
                                  borderColor: '#2A3F90'
                                }}
                              >
                                <CachedIcon />
                              </Button>
                              <Button
                                onClick={() => {
                                  if (!isEmpty(coordsConvert)) {
                                    setDataToSend({
                                      lat: coordsConvert[0],
                                      lng: coordsConvert[1]
                                    });
                                    setCoordSystemIn(coordSystemOut);
                                  } else {
                                    Bert.alert('No hay coordenadas para copiar', 'danger');
                                  }
                                }}
                                variant="outlined"
                                style={{
                                  borderColor: '#2A3F90',
                                  color: '#2A3F90'
                                }}
                              >
                                <ArrowUpwardIcon />
                              </Button>
                              <Button
                                onClick={() => {
                                  if (!isEmpty(dataToSend)) {
                                    setCoordsConvert([dataToSend.lat, dataToSend.lng]);
                                    setCoordSystemOut(coordSystemIn);
                                  } else {
                                    Bert.alert('No hay coordenadas para copiar', 'warning');
                                  }
                                }}
                                variant="outlined"
                                style={{
                                  borderColor: '#2A3F90',
                                  color: '#2A3F90'
                                }}
                              >
                                <ArrowDownwardIcon />
                              </Button>
                              <Button
                                aria-label="Mapa Lidar"
                                onClick={() => {
                                  getLinkLidarMap();
                                }}
                                sx={{ color: '#2A3F90', mb: 2 }}
                                startIcon={<MapIcon />}
                              >
                                Ver mapa
                              </Button>
                            </Stack>
                          </Box>
                          <Box
                            component="form"
                            sx={{
                              display: isMobile === true ? 'column' : 'flex',
                              alignItems: 'center',
                              gap: 2,
                              mb: 2,
                              width: '100%'
                            }}
                            noValidate
                            autoComplete="off"
                          >
                            {' '}
                            <TextField
                              id="outlined-start-adornment"
                              focused
                              fullWidth
                              size="small"
                              label={coordSystemOut === 'EPSG:4326' ? 'Latitud' : 'Y'}
                              value={coordsConvert[0]}
                            />
                            <TextField
                              id="outlined-multiline-flexible"
                              focused
                              fullWidth
                              size="small"
                              label={coordSystemOut === 'EPSG:4326' ? 'Longitud' : 'X'}
                              value={coordsConvert[1]}
                            />
                          </Box>
                        </>
                      )}
                    </>
                  )}
                  {typeToDownload.name === 'catastro' && typeToDownload.otherType !== true && (
                    <>
                      <FormControl fullWidth sx={{ mb: 2 }} variant="outlined" size="small">
                        <InputLabel htmlFor="outlined-adornment-password">
                          Referencia catastral
                        </InputLabel>
                        <OutlinedInput
                          id="outlined-adornment-password"
                          value={inputString}
                          onChange={e => {
                            setGeometryConfig('input');
                            setInputString(e.target.value);
                          }}
                          endAdornment={
                            <>
                              <InputAdornment position="end">
                                <LightTooltip title="Ir" placement="top">
                                  <IconButton
                                    style={{ color: '#2A3F90' }}
                                    onClick={() => {
                                      callToBack([typeFilesSelected], 'search', tableSelected);
                                    }}
                                  >
                                    <NearMeIcon />
                                  </IconButton>
                                </LightTooltip>
                              </InputAdornment>
                              <InputAdornment position="end">
                                <LightTooltip title="Ejemplo: 11035A030000080000AL" placement="top">
                                  <IconButton style={{ color: '#2A3F90' }}>
                                    <HelpOutlineIcon />
                                  </IconButton>
                                </LightTooltip>
                              </InputAdornment>
                            </>
                          }
                          label="Referencia catastral"
                        />
                      </FormControl>
                      {!isEmpty(informationSettings) && (
                        <>
                          <Button
                            aria-label="Configuración"
                            onClick={() => {
                              setOpenInfoCatastro(!openInfoCatastro);
                            }}
                            sx={{ color: '#2A3F90', mb: 2 }}
                            size="small"
                          >
                            {openInfoCatastro === true ? (
                              <KeyboardArrowUpIcon />
                            ) : (
                              <KeyboardArrowDownIcon />
                            )}
                            Información
                          </Button>
                          <Box
                            component="form"
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 2,
                              mb: 2,
                              width: '100%'
                            }}
                            noValidate
                            autoComplete="off"
                          >
                            {openInfoCatastro === true && informationSettings}
                          </Box>
                        </>
                      )}
                    </>
                  )}
                  {typeToDownload.name === 'importar' && importFile === true && (
                    <Box
                      component="form"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                        mb: 2
                      }}
                      noValidate
                      autoComplete="off"
                    >
                      <ImportFileToBackend
                        settingsConnection={MapProps.map.settingsAdvancedMap.connections}
                      />
                    </Box>
                  )}
                  {typeToDownload.name === 'otros' && typeToDownload.otherType !== true && (
                    <>
                      <FormControl fullWidth sx={{ mb: 2 }} variant="outlined" size="small">
                        <InputLabel htmlFor="outlined-adornment-password">
                          {tableSelected.name}
                        </InputLabel>
                        <OutlinedInput
                          id="outlined-adornment-password"
                          value={inputString}
                          onChange={e => {
                            setGeometryConfig('input');
                            setInputString(e.target.value);
                          }}
                          endAdornment={
                            <InputAdornment position="end">
                              <LightTooltip title="Ir" placement="top">
                                <IconButton
                                  style={{ color: '#2A3F90' }}
                                  onClick={() => {
                                    callToBack([typeFilesSelected], 'search', tableSelected);
                                  }}
                                >
                                  <NearMeIcon />
                                </IconButton>
                              </LightTooltip>
                            </InputAdornment>
                          }
                          label={tableSelected.name}
                        />
                      </FormControl>
                      <FormControl fullWidth sx={{ mb: 2 }}>
                        <InputLabel id="demo-select-label">Tabla</InputLabel>
                        <Select
                          id="demo-select"
                          label="Tabla"
                          labelId="demo-select-label"
                          onChange={event => {
                            const value = table.find(item => item.name === event.target.value);
                            setTableSelected(value);
                            pushLoading = false;
                            callToBack([typeFilesSelected], 'PointOnMap', value);
                            setInputString('');
                          }}
                          size="small"
                          value={tableSelected.name}
                        >
                          {table.map(option => (
                            <MenuItem key={option.name} value={option.name}>
                              {option.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </>
                  )}
                  {!isEmpty(typeToDownload.name) && typeToDownload.otherType === true && (
                    <Grid item xs={9} mb={2} alignItems="center">
                      <TextField
                        id="outlined-multiline-flexible"
                        label={typeToDownload.name}
                        multiline
                        value={inputString}
                        onChange={e => setInputString(e.target.value)}
                        fullWidth
                      />
                    </Grid>
                  )}
                  {!isEmpty(table) && !isEmpty(typeToDownload.name) && !isEmpty(typeFilesSelected) && (
                    <Box
                      component="form"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-around',
                        gap: 2,
                        mb: 2,
                        width: '100%'
                      }}
                      noValidate
                      autoComplete="off"
                    >
                      {typeToDownload.name !== 'importar' && (
                        <>
                          <FormControl fullWidth>
                            <InputLabel id="demo-select-label">Producto</InputLabel>
                            <Select
                              labelId="demo-select-label"
                              id="demo-select"
                              label="Producto"
                              size="small"
                              value={
                                isEmpty(typeFilesSelected.product)
                                  ? typeFiles[0].product
                                  : typeFilesSelected.product
                              }
                              onChange={event => {
                                const index = typeFiles.findIndex(
                                  file => file.product === event.target.value
                                );
                                setTypeFilesSelected({
                                  product: event.target.value,
                                  group: [typeFiles[index].group[0]]
                                });
                                setGroupOfProductSelected(typeFiles[index].group);
                              }}
                            >
                              {typeFiles.map(item => (
                                <MenuItem key={item.product} value={item.product}>
                                  {item.product}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          <FormControl fullWidth>
                            <InputLabel id="demo-select-label">Versión</InputLabel>
                            <Select
                              labelId="demo-select-label"
                              id="demo-select"
                              label="Producto"
                              size="small"
                              value={
                                isEmpty(typeFilesSelected.group)
                                  ? groupOfProductSelected[0]
                                  : typeFilesSelected.group[0]
                              }
                              onChange={event => {
                                setTypeFilesSelected({
                                  product: typeFilesSelected.product,
                                  group: [event.target.value]
                                });
                              }}
                            >
                              {groupOfProductSelected.map(item => (
                                <MenuItem key={item} value={item}>
                                  {item}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          <Button
                            variant="outlined"
                            color="success"
                            onClick={() => {
                              pushLoading = true;
                              callToBack([typeFilesSelected], 'cargar', tableSelected);
                            }}
                          >
                            CARGAR
                          </Button>
                        </>
                      )}
                    </Box>
                  )}
                </Grid>
              </>
            ) : (
              <Loading />
            )}
          </Grid>
          {pushLoading === true && (
            <>
              {!isEmpty(firstAnswer) ? (
                <>
                  {firstAnswer.message ? (
                    <h6>{firstAnswer.message}</h6>
                  ) : (
                    <>
                      {!isEmpty(firstAnswer[0].list) && (
                        <>
                          <TableContainer component={Paper}>
                            <Table aria-label="customized table" size="small" stickyHeader>
                              <TableHead>
                                <TableRow>
                                  <StyledTableCell align="left">
                                    {firstAnswer[0].product} - {firstAnswer[0].group}
                                  </StyledTableCell>
                                  <StyledTableCell align="right" />
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {firstAnswer[0].list
                                  .slice(
                                    tablePage * rowsPerPage,
                                    tablePage * rowsPerPage + rowsPerPage
                                  )
                                  .map(row => {
                                    return (
                                      <StyledTableRow key={row.name}>
                                        <StyledTableCell component="th" scope="row">
                                          {row.name}
                                        </StyledTableCell>
                                        <StyledTableCell align="right">
                                          <Stack
                                            color="inherit"
                                            size="small"
                                            direction="row"
                                            justifyContent="flex-end"
                                            alignItems="center"
                                            spacing={0}
                                          >
                                            <IconButton
                                              size="small"
                                              aria-label="centrar"
                                              onClick={() => {
                                                setGoToCoordinates(row.centroide);
                                              }}
                                            >
                                              <NearMeOutlinedIcon />
                                            </IconButton>
                                            <IconButton
                                              size="small"
                                              aria-label="viewData"
                                              onClick={() => {
                                                setViewLinkSelected(row.htmlCreated);
                                                setOpenModalViewLink(true);
                                              }}
                                            >
                                              <VisibilityIcon />
                                            </IconButton>
                                            <IconButton
                                              size="small"
                                              aria-label="download"
                                              onClick={() => {
                                                window.location.href = row.downloadLink;
                                                sendInfoDownloadToBack(row);
                                              }}
                                            >
                                              <DownloadIcon />
                                            </IconButton>
                                          </Stack>
                                        </StyledTableCell>
                                      </StyledTableRow>
                                    );
                                  })}
                              </TableBody>
                            </Table>
                          </TableContainer>
                          <TablePagination
                            rowsPerPageOptions={[10]}
                            component="div"
                            count={firstAnswer[0].list.length}
                            rowsPerPage={rowsPerPage}
                            page={tablePage}
                            onPageChange={handleChangePage}
                          />
                          <Stack direction="row" justifyContent="space-around" spacing={0.5} mb={2}>
                            <Button
                              size="small"
                              aria-label="download"
                              color="success"
                              onClick={() => {
                                handleDownload();
                                sendInfoDownloadToBack(firstAnswer[0]);
                              }}
                              startIcon={<DownloadIcon />}
                            >
                              Descargar
                            </Button>
                            <Button
                              size="small"
                              aria-label="download"
                              color="success"
                              onClick={() => {
                                setOpenModalAllDownload(true);
                              }}
                              startIcon={<DownloadIcon />}
                            >
                              Descargar todos
                            </Button>
                          </Stack>
                          <Modal
                            open={openModalAllDownload}
                            onClose={() => {
                              setOpenModalAllDownload(false);
                              showDownloadLoading = false;
                            }}
                            align="center"
                            style={{ mt: '25%' }}
                          >
                            {bodyAllDownload}
                          </Modal>
                        </>
                      )}
                    </>
                  )}
                </>
              ) : (
                <Loading />
              )}
            </>
          )}
          <Modal
            open={openModalViewLink}
            onClose={() => setOpenModalViewLink(false)}
            style={{ marginTop: '25%', zIndex: 1, position: 'absolute' }}
          >
            {bodyViewLink}
          </Modal>
        </>
      )}
    </>
  );
};
export default DownloadLinksComponent;

DownloadLinksComponent.defaultProps = {
  isMobile: false,
  MapProps: {}
};
DownloadLinksComponent.propTypes = {
  isMobile: PropTypes.bool,
  MapProps: PropTypes.object
};
